import type { NuxtError } from '#app'
import type { OrderApiPayload } from '@api/orders/order/index.hook'

import { useCheckoutStore } from '@stores/checkout'
import { useKidStore } from '@stores/kid'

import { useOrderApi } from '@api/orders/order/index.hook'

interface CheckoutOrderApiOptions {
  onStart?: () => void
  onSuccess?: () => void
  onError?: () => void
  onFinish?: () => void
}

export const useCheckoutOrderApi = async (payload: OrderApiPayload, options?: CheckoutOrderApiOptions): Promise<void | NuxtError> => {
  const checkoutStore = useCheckoutStore()
  const kidStore = useKidStore()

  return useOrderApi(payload, {
    onStart: options?.onStart,
    onSuccess: (order) => {
      const kidId = order?.customer?.kids?.[0]?.id || null

      if (kidId) {
        kidStore.setActiveKid(kidId)
      }
      checkoutStore.setOrder(order)
      checkoutStore.setUpsellOrder(order)

      options?.onSuccess?.()
    },
    onError: options?.onError,
    onFinish: options?.onFinish,
  })
}
